export enum FEATURE_FLAG {
	ENABLE_CAP_FORCE_DELETE = 'ENABLE_CAP_FORCE_DELETE',
	UI_LANGUAGE_LIST = 'UI_LANGUAGE_LIST',
	ORGANIZATION_MANAGEMENT = 'ORGANIZATION_MANAGEMENT',
	USER_PROFILE_SIGNATURE_IMAGE = 'USER_PROFILE_SIGNATURE_IMAGE',
	IN_PAGE_BREADCRUMBS_AND_QUICK_SWITCH_MENU = 'IN_PAGE_BREADCRUMBS_AND_QUICK_SWITCH_MENU',
	CAP_TRANSACTION_FROM_DOCUMENT = 'CAP_TRANSACTION_FROM_DOCUMENT',

	UPLOAD_MANAGEMENT_LOANS = 'UPLOAD_MANAGEMENT_LOANS',
	VESTING_REPORT_EXPORT = 'VESTING_REPORT_EXPORT',
	FUNDS = 'FUNDS',
	EXPORT_DEAL_HOLDINGS_JSON = 'EXPORT_DEAL_HOLDINGS_JSON',
	SKIP_XIRR_CALCULATION = 'SKIP_XIRR_CALCULATION',
	INVESTMENT_DETAILS = 'INVESTMENT_DETAILS',
	INVESTMENT_VEHICLE_DETAILS = 'INVESTMENT_VEHICLE_DETAILS',
	MIP_MULTIPLE_PROGRAMME_ENTITY_UI = 'MIP_MULTIPLE_PROGRAMME_ENTITY_UI',
	// Gates the document signing reminder surfaces (bulk "Send reminders" action,
	// Programme-Settings "Automated emails", and the per-workflow "Email schedule"
	// tab). Dark until the feature is fully rolled out (config.enabled defaults
	// false, so the backend stays dormant while these UI entry points are hidden).
	AUTOMATED_EMAIL_REMINDERS = 'AUTOMATED_EMAIL_REMINDERS',
	// CAP-1062: gates every nominee-structure surface — the "Nominee Structure" card in Deal
	// Settings, the legal/beneficial rail toggles, the Transactions "Interest" column and drawer
	// inputs, and "Manage nominees". With the flag off the whole feature stays dark even on deals
	// whose Deal.hasNomineeStructure is already on.
	CAP_NOMINEE_STRUCTURES = 'CAP_NOMINEE_STRUCTURES',
	// DC-494: gates both halves of Deal Documents — the admin per-person visibility toggle in the
	// Document Library and the investor portal's "Deal Documents" page. Evaluated per deal, so the
	// investor endpoint filters its result set deal by deal rather than gating the whole route.
	INVESTOR_PORTAL_DEAL_DOCUMENTS = 'INVESTOR_PORTAL_DEAL_DOCUMENTS',
	// MIP-2656: gates the bank account lifecycle status badge on bank account tiles.
	// Dark until the verification lifecycle rollout is agreed per environment.
	BANK_ACCOUNT_STATUS = 'BANK_ACCOUNT_STATUS',
	// Gates the entry point to the global document-managed-templates feature
	// (the `/templates` route + editor). Dark by default — the ConfigCat flag
	// defaults to false, so the route redirects away until the feature is
	// enabled per environment/rollout.
	DOCUMENT_MANAGED_TEMPLATES = 'DOCUMENT_MANAGED_TEMPLATES',
	// DC-1079: gates Word documents as master documents — accepting a .docx on upload, the
	// editor it opens in, and generation from the converted document. Dark by default, so the
	// .docx route stays closed until it is enabled per deal.
	DOCX_MASTER_DOCUMENTS = 'DOCX_MASTER_DOCUMENTS',
	// DC-825: gates KYC document certification end to end — the per-proof "require a certified
	// copy" switches and the wording editor, the investor's certification choice on upload, the
	// "Not certified" badge, and the manager-side approval block. Dark by default and evaluated
	// on mipId, so the migration's backfilled requirement stays dormant until a programme is
	// opted in.
	KYC_DOCUMENT_CERTIFICATION = 'KYC_DOCUMENT_CERTIFICATION',
	PROGRAMME_DEFAULTS = 'PROGRAMME_DEFAULTS',
	DEAL_EVENT_LOG = 'DEAL_EVENT_LOG',
}
